export enum PAYMENT_MODE {
  SHOP = 'SHOP',
  PACKAGE = 'PACKAGE',
}
